import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";

const PUBLIC_URL = process.env.PUBLIC_URL ?? "";
const CAMERA_PLACEHOLDER_SRC = `${PUBLIC_URL}/images/camera-snapshot-placeholder.svg`;

/**
 * Centered empty state for Digital Patrol → Live monitoring when no drawing
 * and/or cameras are configured in Administration → Patrol setting.
 */
export function PatrolLiveMonitoringEmptyState({
  title = "Set up Digital Patrol",
  description = "Upload a site drawing and place cameras on it in Administration → Patrol setting to start live monitoring.",
  variant = "both",
}) {
  const showDrawing = variant === "both" || variant === "drawing";
  const showCamera = variant === "both" || variant === "camera";

  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 3,
        p: 4,
        bgcolor: "#f2f2f2",
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: { xs: 3, sm: 5 },
          flexWrap: "wrap",
        }}
      >
        {showDrawing ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 1.5,
            }}
          >
            <Box
              sx={{
                width: 140,
                height: 100,
                borderRadius: "8px",
                bgcolor: "#FFFFFF",
                border: "1px solid #E5E7EB",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
              }}
            >
              <MapOutlinedIcon sx={{ fontSize: 56, color: "#D1D5DB" }} />
            </Box>
            <Typography
              sx={{
                fontFamily: "Roboto, sans-serif",
                fontSize: 13,
                color: "#6B7280",
              }}
            >
              Site drawing
            </Typography>
          </Box>
        ) : null}

        {showCamera ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 1.5,
            }}
          >
            <Box
              component="img"
              src={CAMERA_PLACEHOLDER_SRC}
              alt=""
              sx={{
                width: 140,
                height: 100,
                borderRadius: "8px",
                border: "1px solid #E5E7EB",
                objectFit: "cover",
                bgcolor: "#0f172a",
                boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
              }}
            />
            <Typography
              sx={{
                fontFamily: "Roboto, sans-serif",
                fontSize: 13,
                color: "#6B7280",
              }}
            >
              Camera placement
            </Typography>
          </Box>
        ) : null}
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1,
          maxWidth: 480,
          textAlign: "center",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Roboto, sans-serif",
            fontSize: 16,
            fontWeight: 600,
            color: "#4A5565",
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            fontFamily: "Roboto, sans-serif",
            fontSize: 14,
            color: "#6B7280",
            lineHeight: 1.5,
          }}
        >
          {description}
        </Typography>
      </Box>
    </Box>
  );
}
